import PropTypes from 'prop-types';
import React from 'react';

import Comment from './Comment';
import styles from './Comments.module.css';

const Comments = ({ comments, i18n }) => {
  if (!comments || !comments.length) {
    return null;
  }

  return (
    <div className={styles.comments}>
      <h3 className={styles.title}>{i18n('page.question.answers.comments')}</h3>
      {comments.map((comment) => (
        <Comment key={comment.id} comment={comment} />
      ))}
    </div>
  );
};

Comments.propTypes = {
  comments: PropTypes.array,
  i18n: PropTypes.func,
};

export default Comments;
